import { z } from 'zod'

export const groupMemberResponseSchema = z.object({
  id: z.string().guid(),
  userId: z.string().guid(),
  userName: z.string().nullable(),
  userEmail: z.string(),
  role: z.string(),
  status: z.string(),
  sharePercentage: z.number(),
  alias: z.string().nullable(),
  joinedAt: z.string(),
})

export type GroupMemberResponseDto = z.infer<typeof groupMemberResponseSchema>

export const pendingEmailInvitationSchema = z.object({
  email: z.string(),
  createdAt: z.string(),
  expiresAt: z.string(),
})

export type PendingEmailInvitationDto = z.infer<typeof pendingEmailInvitationSchema>

export const groupResponseSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
  description: z.string().nullable(),
  tag: z.string().nullable(),
  createdById: z.string().guid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  members: z.array(groupMemberResponseSchema),
  pendingEmailInvitations: z.array(pendingEmailInvitationSchema).optional(),
})

export type GroupResponseDto = z.infer<typeof groupResponseSchema>
